// extracted by mini-css-extract-plugin
export default {"mobileGrid":"styles_mobileGrid__3PdN7","mainArea":"styles_mainArea__kbu1y","title":"styles_title__GueTB","subtitle":"styles_subtitle__9t8Xm"};